import { WishlistElementHeadless } from "https://cdn.jsdelivr.net/npm/@appmate/wishlist@4.29.7/wishlist-element-headless.js";

class WishlistButtonHeadless extends WishlistElementHeadless {
  getStateConfig() {
    this.host.hidden = false;
    return {
      productInfo: true,
    };
  }

  getEventConfig() {
    return {
      "click": this.handleClick,
    };
  }

  handleClick() {
    if (this.productInfo.inWishlist) {
      return this.app.removeWishlistItem(this.productInfo);
    } else {
      return this.app.addWishlistItem(this.productInfo);
    }
  }

  updated() {
    this.host.classList.toggle("wk-selected", this.productInfo.inWishlist);

    this.host.setAttribute('aria-label', this.getText());
  }

  getText() {
    if (this.productInfo.inWishlist) {
      return "Remove from Wishlist";
    }
    return "Add to Wishlist";
  }
};

window.headlessElements.define("wishlist-button-headless", WishlistButtonHeadless);
